import { routes } from "src/constants/routes.constants.ts";
import { AccountMovements } from "src/admin/bill/account-movements/AccountMovements.tsx";
import { Balance } from "src/admin/bill/balance/Balance.tsx";

export const billRoute = {
  path: routes.admin.bill.root,
  lazy: () => import("src/admin/bill/bill.tsx"),
  children: [
    {
      index: true,
      element: <Balance />,
    },
    {
      path: routes.admin.bill.account_movements.root,
      element: <AccountMovements />,
    },
  ],
};
